<template>
     <el-dialog :visible.sync="functionDialog" width="25%" top="15vh" center style="border: 1px solid #01DFD7" :close-on-click-modal = false
               :close-on-press-escape = false @close="closeDialog">
        <el-card>
           <el-table :data="response" style="margin:auto;width:calc(100% - 30px)" height="300" border :row-style="{ height: '0.3%' }" :cell-style="{ padding: '0.25%' }"
                        :header-cell-style="{background:'#01DFD7',color:'#fff'}">
                    <el-table-column label="权限名称" align="center" prop="name"></el-table-column>
                </el-table>
        </el-card>
     </el-dialog>
</template>
<script>
import {getPostOrPositionFunction} from '../../api/sys/position.js'
export default {
    data(){
        return {
            functionDialog: false,
            response: []
        }
    },
    methods: {
        init(item){
            this.functionDialog = true;
            //获取权限列表
            getPostOrPositionFunction(item).then(result=>{
                this.response = result.data;
            })
        },
        closeDialog(){
            this.functionDialog =  false;
            this.response = [];
        }
    }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/sys/function.vue